import { BitfRestPathBuilder } from '../rest-parser/bitf-rest-path.builder';

export class BitfStrapiPathBuilder extends BitfRestPathBuilder {}
